import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'
import Link from 'next/link'

import Button from 'components/elements/Button'
import MobxCheckbox from 'components/elements/fields/MobxCheckbox/MobxCheckbox'
import MessageBlock from 'components/elements/MessageBlock'
import {useW2Store} from 'src/utils/contexts/RootStore.context'

import s from './FormW2Finish.module.scss'

const cx = cn.bind(s)

interface IFormW2FinishProps {
	className?: string
}

const FormW2Finish: FC<IFormW2FinishProps> = ({className}) => {
	const w2Store = useW2Store()
	return (
		<div className={cx('finish', className)}>
			{w2Store.errorMessage && (
				<MessageBlock type="error" className={cx('error-block')} message={w2Store.errorMessage} />
			)}
			<div className={cx('finish__checkboxes')}>
				<MobxCheckbox
					label="I agree that I will not use this site for any illegal purposes"
					value={false}
					required
					name="illegalAgreement"
					store={w2Store.form}
				/>
				<MobxCheckbox
					label={
						<>
							Please accept our <Link href="/terms">Terms of Use</Link> and{' '}
							<Link href="/privacy-policy">Privacy Policy</Link>
						</>
					}
					value={false}
					required
					name="terms"
					store={w2Store.form}
				/>
			</div>
			<Button
				disabled={!!w2Store.errorMessage}
				data-testid="preview"
				size="big"
				type="submit"
				className={cx('finish__button')}>
				Preview
			</Button>
		</div>
	)
}

FormW2Finish.displayName = 'FormW2Finish'

export default observer(FormW2Finish)
